// extracted by mini-css-extract-plugin
export default {"card":"style_card__UYsOz","content":"style_content__DAQtH","pic":"style_pic__utmMD","text":"style_text__ovIGE","name":"style_name__Hzkpp"};